<div class="fixed top-0 left-0 right-0 bottom-0 bg-(--loading-overlay-color) opacity-95 z-2"></div>
<div class="fixed inset-0 z-3 overflow-y-auto">
    <div class="min-h-dvh flex flex-col justify-center items-center py-8">
    <span class="w-full px-3 lg:max-w-4xl flex flex-col gap-3">
        <span class="flex flex-col">
            <div class="text-white text-3xl font-semibold mb-1">Generate IDs</div>
            <div class="text-white text-lg font-semibold mb-1">Number of IDs to generate</div>
        </span>
        <mat-form-field appearance="fill" id="new-project" class="w-full text-white">
            <mat-label></mat-label>
            <input type="number" matInput [value]="count() ?? ''" (input)="onCountChange($event.target.value)" min="0"
                max="999" />
        </mat-form-field>
        <span class="flex flex-row gap-5">
            <button matButton="filled" class="min-w-[100px]!" (click)="add()" [disabled]="isSubmitting()">Add</button>
            <a matButton="filled" class="min-w-[100px]!" routerLink="..">Cancel</a>
        </span>
    </span>
</div>
</div>
